import React from 'react';
import { store } from '../redux';
import { changeKey } from '../redux/apply-change';
export const fieldAuthorKey = (field) => changeKey({
    kind: 'fieldWrite',
    pageId: field.pageId,
    section: field.section
        ? { path: field.section.path, id: field.section.id }
        : undefined,
    fieldType: field.fieldType,
    fieldName: field.fieldName,
    at: ''
});
export const useFieldAuthor = (field) => {
    const key = React.useMemo(() => fieldAuthorKey(field), [
        field.pageId,
        field.fieldType,
        field.fieldName,
        JSON.stringify(field.section?.path),
        field.section?.id
    ]);
    const read = React.useCallback(() => {
        const state = store.getState();
        return state.remote?.authors?.[key];
    }, [key]);
    const [author, setAuthor] = React.useState(read);
    React.useEffect(() => {
        setAuthor(read());
        return store.subscribe(() => {
            setAuthor(previous => {
                const next = read();
                if (previous?.sub === next?.sub && previous?.at === next?.at) {
                    return previous;
                }
                return next;
            });
        });
    }, [read]);
    return author;
};
